import { Model } from 'dva'
import { TTSAgent } from '../types'
import { TtsService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const TTSAgents: Model = {
  namespace: 'ttsAgents',
  state: {
    list: [],
  },
  effects: {
    *list(
      { id, useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let ttsAgents = yield select((state: any) =>
          state.ttsAgents.list.filter((item: TTSAgent) => item.provider.id === id)
        )
        if (!(ttsAgents.length > 0 && useCache)) {
          ttsAgents = yield call(TtsService.ttsModelsList, {
            providerPk: id,
          })
          yield put({ type: 'modifyList', payload: ttsAgents })
        }
        onSuccess(ttsAgents)
      } catch (err: any) {
        FailureHandler('Error fetching TTS Models', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { providerId, id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let ttsAgent = yield select((state: any) =>
          state.ttsAgents.list.find((ttsAgent: TTSAgent) => ttsAgent.id === id)
        )
        if (!ttsAgent) {
          ttsAgent = yield call(TtsService.ttsModelsRetrieve, {
            id: id,
            providerPk: providerId,
          })
        }
        yield put({ type: 'modifyList', payload: ttsAgent })
        onSuccess(ttsAgent)
      } catch (err) {
        FailureHandler('Could not find the TTS Model!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { providerId, data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TtsService.ttsModelsCreate, {
          requestBody: data,
          providerPk: providerId,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a TTS Model!', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, providerId, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TtsService.ttsModelsPartialUpdate, {
          id: id,
          providerPk: providerId,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a TTS Model!', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { idParentAlias, id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(TtsService.ttsModelsDestroy, {
          id: id,
          providerPk: idParentAlias,
        })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a ttsAgent', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: TTSAgent) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: TTSAgent) => !action.payload.map((p: TTSAgent) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: TTSAgent) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetTTSAgents(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default TTSAgents
